import { render } from "./ViewContent.vue?vue&type=template&id=6448c68c"
const script = {}

import exportComponent from "/home/harris/Projects/cspd.com.cy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__